import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Bien } from 'src/app/core/interfaces/bien';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { UserService } from 'src/app/core/user/user.service';
import { UTILS } from 'src/app/core/const/const';

@Component({
  selector: 'app-card-bien',
  templateUrl: './card-bien.component.html',
  styleUrls: ['./card-bien.component.scss'],
})
export class CardBienComponent implements OnInit {
  @Input() bien: Partial<any> = {};
  @Input() parent: string = 'liste';
  @Output() bienClicked = new EventEmitter();
  @Output() saveOrUpdate = new EventEmitter();
  @Input() greenTools: boolean = false;
  @Input() project: boolean = false;

  @Input() showActifPub: boolean = false;
  @Input() showIconFavorite: boolean = true;
  @Input() showIconOffre: boolean = false;
  @Input() showIconPartAcc: boolean = false;
  @Input() showIconVisite: boolean = false;
  @Input() showIconPrint: boolean = true;

  @Input() btnAdmin = true;
  @Input() userConnected?: any;
  messageConfirmation: any = '';
  statusConfirmation = 'success';
  showAlert = false;
  constructor(
    private _userService: UserService,
    private _dashboardService: DashboardService
  ) {}
  ngOnInit(): void {
    this.userConnected = this._userService.getUser();
  }

  getBienUrl(bien: any): any[] {
    if (!bien || !bien.id) return ['/accueil'];
    const option = bien.vente ? 'biens-a-vendre' : 'biens-a-louer';
    const type = UTILS.replaceSpace(bien.type || 'bien');
    const ville = UTILS.replaceSpace(bien.ville || 'commune');
    const pieces = ((bien.property?.pieces || 1) > 1 ? (bien.property?.pieces || 1) + '-pieces' : (bien.property?.pieces || 1) + '-piece');
    const chambres = ((bien.property?.room || 0) > 1 ? (bien.property?.room || 0) + '-chambres' : (bien.property?.room || 0) + '-chambre');
    const id = bien.id;
    return ['/', option, type, ville, pieces, chambres, id];
  }

  onAddFavoris(id: number) {
    this.statusConfirmation = 'success';
    this.messageConfirmation = '';
    this.showAlert = false;
    this._dashboardService.addFavoris(id).subscribe((response: any) => {
      if (response.code != 202 || response.code != 200) {
        this.statusConfirmation = 'error';
      }
      this.messageConfirmation = response['data'].message;
      this.showAlert = true;
      setTimeout(() => {
        this.saveOrUpdate.emit();
      }, 2000);
    });
  }
  onDeleteFavoris(id: number) {
    this.statusConfirmation = 'success';
    this.messageConfirmation = '';
    this.showAlert = false;
    this._dashboardService.deleteFavoris(id).subscribe((response: any) => {
      if (response.code != 202 || response.code != 200) {
        this.statusConfirmation = 'error';
      }
      this.messageConfirmation = response['data'].message;
      this.showAlert = true;
      setTimeout(() => {
        this.saveOrUpdate.emit();
      }, 2000);
    });
  }

  emitEventClicked(bien: any) {
    if(bien.actif_tdm && [1, 3, 4].includes(bien.status.id)){
      this.bienClicked.emit(bien.id)
    }
  }
  manageFavorite(bien: any) {
    bien.favorite = !bien.favorite;
  }
}
